import { useCurrentModule } from '../components/ModuleProvider';
import { TWO_YEAR_CYCLE_ID, YEARLY_CYCLE_ID } from '../utils/consts';
export const useMonthlyCycleSavings = productId => {
  var _yearlyPricingData$cy, _twoYearPricingData$c;
  const module = useCurrentModule();
  const enabled = Boolean(productId);
  const {
    data: yearlyPricingData,
    isLoading: isYearlyPricingLoading
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchCyclePricing({
    productId: productId ?? '',
    cycleId: YEARLY_CYCLE_ID
  }, enabled);
  const {
    data: twoYearPricingData,
    isLoading: isTwoYearPricingLoading
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchCyclePricing({
    productId: productId ?? '',
    cycleId: TWO_YEAR_CYCLE_ID
  }, enabled);
  const yearlySavings = yearlyPricingData == null || (_yearlyPricingData$cy = yearlyPricingData.cyclePricing) == null || (_yearlyPricingData$cy = _yearlyPricingData$cy.savings) == null || (_yearlyPricingData$cy = _yearlyPricingData$cy.fixedAmount) == null ? void 0 : _yearlyPricingData$cy.formattedAmount;
  const twoYearSavings = twoYearPricingData == null || (_twoYearPricingData$c = twoYearPricingData.cyclePricing) == null || (_twoYearPricingData$c = _twoYearPricingData$c.savings) == null || (_twoYearPricingData$c = _twoYearPricingData$c.fixedAmount) == null ? void 0 : _twoYearPricingData$c.formattedAmount;
  return {
    yearlySavings,
    twoYearSavings,
    hasTwoYearCycle: Boolean(twoYearPricingData == null ? void 0 : twoYearPricingData.cyclePricing),
    hasSavingsAmounts: Boolean(yearlySavings && twoYearSavings),
    isLoading: enabled && (isYearlyPricingLoading || isTwoYearPricingLoading)
  };
};
//# sourceMappingURL=useMonthlyCycleSavings.js.map